export const POLY_LAYERS = {
  "polygons-conquest": "Conquest of the Promised Land",
  "polygons-settlement": "Settlement of the Promised Land",
  "polygons-davidic": "Kingdom of David and Solomon",
  "polygons-messianic": "Israel During the Time of Jesus",
};

export const ZOOM_OPTIONS = [0.1, 3, 3.3, 5, 6, 7, 8, 8.5, 9, 9.5];

export const ZOOM_STEPS = [
  { step: 0, zoom: 0.5, fade: 0 },
  { step: 3.3, zoom: 0.5, fade: 0 },
  { step: 5.5, zoom: 5.5, fade: 0 },
  { step: 6.5, zoom: 5.5, fade: 0 },
  { step: 7.3, zoom: 7.3, fade: 0 },
  { step: 8.3, zoom: 8.3, fade: 0 },
  { step: 9, zoom: 9.0, fade: 0.5 },
  { step: 9.5, noFilterNeeded: true },
  { step: 22, noFilterNeeded: true },
];

export const MAP_VIEWPORTS = {
  default: {
    center: [35.532, 31.885],
    zoom: 7.0,
    speed: 0.25,
    bearing: 0,
    pitch: 0,
  },
  "polygons-conquest": {
    center: [35.338772116279074, 32.34155601399762],
    zoom: 6.14,
    speed: 0.25,
    bearing: 0,
    pitch: 0,
  },
  "polygons-settlement": {
    center: [35.39000587578994, 31.969226694307423],
    zoom: 6.42,
    speed: 0.25,
    bearing: 0,
    pitch: 0,
  },
  "polygons-davidic": {
    center: [36.539366885346, 33.38759953888861],
    zoom: 5.5,
    speed: 0.45,
    bearing: 0,
    pitch: 0,
  },
  "polygons-messianic": {
    center: [35.47168605959064, 32.48903607022501],
    zoom: 6.5,
    speed: 0.25,
    bearing: 0,
    pitch: 0,
  },
};

export const MODERN_LAYERS = {
  //Layer ID : Source Layer
  "aeroway-polygon": "aeroway",
  "aeroway-line": "aeroway",
  // "building-outline": "building", //Deleted After style update
  building: "building",
  "building-underground": "building",
  "tunnel-street-minor-low": "road",
  "tunnel-street-minor-case": "road",
  "tunnel-primary-secondary-tertiary-case": "road",
  "tunnel-major-link-case": "road",
  "tunnel-motorway-trunk-case": "road",
  "tunnel-construction": "road",
  "tunnel-path-trail": "road",
  "tunnel-path-cycleway-piste": "road",
  "tunnel-path": "road",
  "tunnel-steps": "road",
  "tunnel-pedestrian": "road",
  "tunnel-major-link": "road",
  "tunnel-street-minor": "road",
  "tunnel-primary-secondary-tertiary": "road",
  "tunnel-oneway-arrow-blue": "road",
  "tunnel-motorway-trunk": "road",
  "tunnel-oneway-arrow-white": "road",
  ferry: "road",
  "ferry-auto": "road",
  "road-path-bg": "road",
  "road-steps-bg": "road",
  "road-pedestrian-case": "road",
  "road-path-trail": "road",
  "road-path-cycleway-piste": "road",
  "road-path": "road",
  "road-steps": "road",
  "road-pedestrian": "road",
  "road-pedestrian-polygon-fill": "road",
  "road-pedestrian-polygon-pattern": "road",
  "golf-hole-line": "road",
  "turning-feature-outline": "road",
  "road-minor-low": "road",
  "road-minor-case": "road",
  "road-street-low": "road",
  "road-street-case": "road",
  "road-secondary-tertiary-case": "road",
  "road-primary-case": "road",
  "road-major-link-case": "road",
  "road-motorway-trunk-case": "road",
  "road-construction": "road",
  "road-major-link": "road",
  "road-polygon": "road",
  "road-minor": "road",
  "road-street": "road",
  "road-secondary-tertiary": "road",
  "road-primary": "road",
  "road-oneway-arrow-blue": "road",
  "road-motorway-trunk": "road",
  "road-rail": "road",
  "road-rail-tracks": "road",
  "level-crossing": "road",
  "road-oneway-arrow-white": "road",
  "turning-feature": "road",
  "gate-fence-hedge": "structure",
  "bridge-path-bg": "road",
  "bridge-steps-bg": "road",
  "bridge-pedestrian-case": "road",
  "bridge-path-trail": "road",
  "bridge-path-cycleway-piste": "road",
  "bridge-path": "road",
  "bridge-steps": "road",
  "bridge-pedestrian": "road",
  "bridge-street-minor-low": "road",
  "bridge-street-minor-case": "road",
  "bridge-primary-secondary-tertiary-case": "road",
  "bridge-major-link-case": "road",
  "bridge-motorway-trunk-case": "road",
  "bridge-construction": "road",
  "bridge-major-link": "road",
  "bridge-street-minor": "road",
  "bridge-primary-secondary-tertiary": "road",
  "bridge-oneway-arrow-blue": "road",
  "bridge-motorway-trunk": "road",
  "bridge-major-link-2-case": "road",
  "bridge-motorway-trunk-2-case": "road",
  "bridge-major-link-2": "road",
  "bridge-motorway-trunk-2": "road",
  "bridge-oneway-arrow-white": "road",
  "bridge-rail": "road",
  "bridge-rail-tracks": "road",
  "aerialway-bg": "road",
  aerialway: "road",
  "admin-1-boundary-bg": "admin",
  "admin-0-boundary-bg": "admin",
  "admin-1-boundary": "admin",
  "admin-0-boundary": "admin",
  "admin-0-boundary-disputed": "admin",
  "building-number-label": "housenum_label",
  "block-number-label": "place_label",
  "road-label-outdoors": "road",
  "road-intersection": "road",
  "road-number-shield": "road",
  "road-exit-shield": "motorway_junction",
  "path-pedestrian-label": "road",
  "golf-hole-label": "road",
  "ferry-aerialway-label": "road",
  "poi-label": "poi_label",
  "transit-label": "transit_stop_label",
  "airport-label": "airport_label",
  "settlement-subdivision-label": "place_label",
  "settlement-minor-label": "place_label",
  "settlement-major-label": "place_label",
  "state-label": "place_label",
  "country-label": "place_label",
};
